<div class="relative bg-gray-50 h-[calc(100vh-120px)] overflow-hidden flex flex-col">
  
  <div class="relative z-[10] w-full bg-white shadow-sm flex-none">
    <div class="w-full h-[70px] bg-[#FFE9A2] flex justify-center items-center shadow-sm rounded-b-[24px] relative z-[2]">
      
      <div
        class="absolute left-4 w-[40px] h-[40px] bg-white/80 hover:bg-white shadow-sm rounded-full flex justify-center items-center cursor-pointer active:scale-95 transition-all"
        (click)="goBack()"
      >
        <img src="icons/Payment/back-payment.png" alt="back" class="w-[20px] h-[20px] object-contain opacity-70" />
      </div>

      <p class="text-[#5E5D5D] text-[20px] font-bold text-center">
        {{ currentLang === "TH" ? "ขอส่วนลด & ประทับตรา" : "Discount & Stamp" }}
      </p>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto p-4 space-y-4 pb-24">

    <div class="bg-white rounded-2xl shadow-sm p-5 border border-gray-100 relative overflow-hidden">
      <div class="absolute top-0 left-0 w-1 h-full bg-[#ffc720]"></div>

      <div class="flex flex-col gap-5">
        
        <div>
          <label class="block text-[#5E5D5D] text-sm font-bold mb-2 flex items-center gap-2">
             <div class="w-7 h-7 rounded-full bg-green-100 flex items-center justify-center text-green-600">
                <i class="fa fa-map-marker text-xs"></i> </div>
             {{ currentLang === "TH" ? "สถานที่จอด / ห้าง" : "Parking location" }}
             <span class="text-red-500">*</span>
          </label>
          <div class="flex gap-2">
            <input
              [(ngModel)]="providerName"
              class="bg-gray-50 text-gray-600 font-medium rounded-xl border border-gray-200 flex-1 py-2.5 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-300 transition-all placeholder:text-gray-300"
              type="text"
              [placeholder]="currentLang === 'TH' ? 'กรุณาเลือกสถานที่จอด' : 'Select location'"
              readonly
            />
            <button
              (click)="openProviderModol()"
              class="bg-green-500 hover:bg-green-600 text-white rounded-xl px-4 py-2 text-sm font-bold shadow-sm active:scale-95 transition-all whitespace-nowrap"
            >
              {{ currentLang === "TH" ? "เลือก" : "Select" }}
            </button>
          </div>
        </div>

        <div>
          <label class="block text-[#5E5D5D] text-sm font-bold mb-2 flex items-center gap-2">
            <div class="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center text-blue-600">
                <i class="fa fa-car text-xs"></i>
             </div>
            {{ currentLang === "TH" ? "ทะเบียนรถ" : "License plate" }}
            <span class="text-red-500">*</span>
          </label>
          <div class="flex gap-2">
            <input
              [(ngModel)]="license_plate"
              class="bg-gray-50 text-gray-600 font-medium rounded-xl border border-gray-200 flex-1 py-2.5 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-300 transition-all placeholder:text-gray-300"
              type="text"
              readonly
              [placeholder]="currentLang === 'TH' ? 'กข 1234 (เลือกทะเบียน)' : 'Select License Plate'"
            />
            <button
              (click)="openMallSelector()"
              class="bg-blue-500 hover:bg-blue-600 text-white rounded-xl px-4 py-2 text-sm font-bold shadow-sm active:scale-95 transition-all whitespace-nowrap"
            >
              {{ currentLang === "TH" ? "เลือก" : "Select" }}
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-sm p-5 border border-gray-100">
      
      <div class="flex items-center gap-2 mb-4 border-b border-gray-100 pb-2">
        <div class="p-2 bg-yellow-300 rounded-lg">
          <img src="icons/capture-image.png" alt="Icon" class="w-5 h-5 opacity-70" /> 
        </div>
        <p class="text-[#5E5D5D] font-bold text-base">
          {{ currentLang === "TH" ? "แนบรูปถ่าย / ใบเสร็จ" : "Attach Photo / Receipt" }}
          <span class="text-red-500">*</span>
        </p>
      </div>

      <div class="relative w-full min-h-[220px] bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center overflow-hidden hover:bg-yellow-50 hover:border-yellow-300 transition-all group">
        
        <div *ngIf="previewUrl" class="w-full h-full flex items-center justify-center p-2 relative">
          <img
            [src]="previewUrl"
            alt="preview"
            class="max-h-[280px] object-contain rounded-lg shadow-sm cursor-pointer transition-transform duration-300 group-hover:scale-105"
            (click)="expandImage()"
          />
          <div class="absolute bottom-2 right-2 bg-black/60 backdrop-blur text-white text-[10px] px-2 py-1 rounded-md pointer-events-none">
            <i class="fa fa-search-plus mr-1"></i>{{ currentLang === "TH" ? "ขยาย" : "Zoom" }}
          </div>
        </div>

        <div *ngIf="!previewUrl" class="flex flex-col items-center justify-center text-gray-400 py-6 pointer-events-none">
          <div class="w-12 h-12 mb-2 rounded-full bg-gray-200 flex items-center justify-center group-hover:bg-yellow-200 transition-colors">
             <svg class="w-6 h-6 text-gray-500 group-hover:text-yellow-700" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
          </div>
          <p class="text-xs font-medium group-hover:text-yellow-700">
            {{ currentLang === "TH" ? "แตะเพื่อเลือกรูปภาพ" : "Tap to select image" }}
          </p>
        </div>

        <div *ngIf="!previewUrl" class="absolute inset-0 cursor-pointer" (click)="cameraInput.click()"></div>
      </div>

      <input type="file" accept="image/*" capture="environment" class="hidden" (change)="capture($event)" #cameraInput />

      <button
        class="mt-4 w-full py-2.5 rounded-xl border border-yellow-500 text-yellow-500 font-bold shadow-sm flex justify-center items-center gap-2 hover:bg-yellow-50 active:bg-yellow-100 transition-all text-sm"
        (click)="cameraInput.click()"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path></svg>
        {{ currentLang === "TH" ? "อัปโหลด / ถ่ายใหม่" : "Upload / Retake" }}
      </button>

      <div class="mt-4 bg-orange-50 border border-orange-100 rounded-xl p-3 text-xs text-orange-800 flex gap-2 items-start">
        <svg class="w-4 h-4 text-orange-500 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
        <div class="space-y-0.5">
          <p class="font-bold">{{ currentLang === "TH" ? "ข้อควรระวัง" : "Note" }}</p>
          <p class="opacity-80">{{ currentLang === "TH" ? "ถ่ายใบเสร็จให้ชัดเจน เห็นรายละเอียดครบถ้วน" : "Take a clear and complete receipt photo." }}</p>
          <p class="opacity-80">{{ currentLang === "TH" ? "ใบเสร็จใช้ได้ภายในวันที่ใช้บริการเท่านั้น" : "Receipt is valid only on the date of service." }}</p>
        </div>
      </div>
    </div>

    <div class="pt-2 text-center">
      <p class="text-[12px] text-gray-400 mb-3 px-4">
        {{ currentLang === "TH" 
          ? "ตรวจสอบความถูกต้องแล้วกดปุ่มด้านล่าง ระบบจะแจ้งผลผ่าน LINE" 
          : "Verify details and click below. Results will be sent via LINE." }}
      </p>
      <button
        (click)="openModal_Confirm()"
        class="w-full bg-[#ffc720] hover:bg-[#eeb610] text-white text-lg font-bold py-3.5 px-6 rounded-2xl shadow-lg shadow-yellow-100 transition-all duration-200 active:scale-95 flex justify-center items-center gap-2"
      >
        <span>{{ currentLang === "TH" ? "ยืนยันการขอส่วนลด" : "Submit Request" }}</span>
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0 1 18 0z"></path></svg>
      </button>
    </div>

  </div> 
</div>


<div *ngIf="isImageExpanded" class="fixed inset-0 bg-black/90 flex items-center justify-center z-[100] backdrop-blur-sm p-4" (click)="closeExpandedImage()">
  <div class="relative max-w-full max-h-full">
    <img [src]="previewUrl" alt="Expanded preview" class="max-w-full max-h-[80vh] rounded-lg shadow-2xl object-contain" />
    <button class="absolute -top-10 right-0 text-white bg-white/20 hover:bg-white/30 rounded-full p-2 backdrop-blur">
       <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
    </button>
  </div>
</div>

<div *ngIf="modalSelectProvider" class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 transition-all">
  <div class="bg-white w-full max-w-md rounded-2xl shadow-2xl flex flex-col max-h-[85vh] overflow-hidden animate-fade-in-up">
    
    <div class="p-4 bg-[#FFE9A2] flex justify-between items-center rounded-t-2xl">
      <h2 class="text-lg font-bold text-[#5E5D5D]">
        {{ currentLang === "TH" ? "เลือกสถานที่จอด" : "Select Location" }}
      </h2>
      <button (click)="modalSelectProvider = false" class="bg-white/50 p-1 rounded-full text-[#5E5D5D] hover:bg-white hover:text-red-500 transition-colors">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>

    <div class="p-3 bg-white border-b border-gray-100">
      <div class="relative">
        <span class="absolute left-3 top-2.5 text-gray-400">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
        </span>
        <input
          type="text"
          [(ngModel)]="searchProvider"
          [placeholder]="currentLang === 'TH' ? 'ค้นหาชื่อ...' : 'Search...'"
          class="w-full pl-10 pr-4 py-2 bg-gray-50 border-transparent focus:bg-white border focus:border-yellow-400 rounded-xl text-sm focus:outline-none transition-all"
        />
      </div>
    </div>

    <div class="flex-1 overflow-y-auto p-2 space-y-1">
      <div
        *ngFor="let provider of filteredProviders()"
        (click)="selectProvider(provider)"
        class="p-3 rounded-xl hover:bg-yellow-50 cursor-pointer border border-transparent hover:border-yellow-200 transition-all group"
      >
        <div class="font-semibold text-gray-700 group-hover:text-yellow-700">{{ provider.name }}</div>
        <div class="text-xs text-gray-400 mt-0.5">{{ provider.address }}</div>
      </div>
      
      <div *ngIf="filteredProviders().length === 0" class="flex flex-col items-center justify-center py-10 text-gray-400 gap-2">
         <div class="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center"><i class="fa fa-search text-gray-300"></i></div>
         <span class="text-sm">{{ currentLang === "TH" ? "ไม่พบข้อมูล" : "No results found" }}</span>
      </div>
    </div>
  </div>
</div>


<div *ngIf="modalSelectLincense" class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 transition-all">
  <div class="bg-white w-full max-w-md rounded-2xl shadow-2xl flex flex-col max-h-[85vh] overflow-hidden animate-fade-in-up">
    
    <div class="p-4 bg-[#FFE9A2] flex justify-between items-center rounded-t-2xl">
      <h2 class="text-lg font-bold text-[#5E5D5D]">
        {{ currentLang === "TH" ? "เลือกทะเบียนรถ" : "Select License Plate" }}
      </h2>
      <button (click)="modalSelectLincense = false" class="bg-white/50 p-1 rounded-full text-[#5E5D5D] hover:bg-white hover:text-red-500 transition-colors">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>

    <div class="p-3 bg-white border-b border-gray-100">
      <div class="relative">
        <span class="absolute left-3 top-2.5 text-gray-400">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
        </span>
        <input
          type="text"
          [(ngModel)]="searchLicense"
          [placeholder]="currentLang === 'TH' ? 'ค้นหาทะเบียน...' : 'Search plate...'"
          class="w-full pl-10 pr-4 py-2 bg-gray-50 border-transparent focus:bg-white border focus:border-yellow-400 rounded-xl text-sm focus:outline-none transition-all"
        />
      </div>
    </div>

    <div class="flex-1 overflow-y-auto p-2 space-y-1">
      <div
        *ngFor="let transaction of filteredLicense()"
        (click)="selectLicense(transaction)"
        class="p-3 rounded-xl hover:bg-yellow-50 cursor-pointer border border-transparent hover:border-yellow-200 transition-all group"
      >
        <div class="font-semibold text-gray-800 flex items-center gap-2">
            <span class="bg-gray-100 border border-gray-200 text-gray-500 text-[10px] px-1.5 py-0.5 rounded font-mono">PLATE</span>
            <span class="text-lg group-hover:text-yellow-700">{{ transaction.license }}</span>
        </div>
        <div class="text-xs text-gray-500 mt-1 flex items-center gap-1 pl-1">
            <span class="w-1.5 h-1.5 rounded-full bg-green-400"></span>
            {{ currentLang === "TH" ? "เข้าจอดเมื่อ" : "Entry" }}: {{ transaction.entryDate | date : "dd/MM/yyyy HH:mm" }}
        </div>
      </div>
      
      <div *ngIf="filteredLicense().length === 0" class="flex flex-col items-center justify-center py-10 text-gray-400 gap-2">
         <div class="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center"><i class="fa fa-car text-gray-300"></i></div>
         <span class="text-sm">{{ currentLang === "TH" ? "ไม่พบข้อมูล" : "No results found" }}</span>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showModal_confirm" class="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
  <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 relative animate-bounce-in text-center">
    
    <div class="mx-auto mb-4 w-16 h-16 bg-yellow-100 text-yellow-500 rounded-full flex items-center justify-center shadow-inner">
       <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0 1 18 0z"></path></svg>
    </div>
    
    <h3 class="mb-2 text-xl font-bold text-[#5E5D5D]">
      {{ currentLang === "TH" ? "ยืนยันการขอส่วนลด?" : "Confirm Request?" }}
    </h3>
    
    <p class="mb-6 text-sm text-gray-500 leading-relaxed">
      {{
        currentLang === "TH"
          ? "กรุณาตรวจสอบข้อมูลให้ถูกต้อง หากยืนยันแล้วจะไม่สามารถแก้ไขได้"
          : "Please review carefully. Once submitted, this action cannot be undone."
      }}
    </p>

    <div class="flex gap-3">
      <button
          (click)="closeModal_Confirm()"
          class="flex-1 py-3 px-4 text-sm font-bold text-gray-600 bg-gray-100 rounded-xl hover:bg-gray-200 transition-all"
      >
          {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
      </button>
      <button
        (click)="save()"
        class="flex-1 text-white bg-[#ffc720] hover:bg-[#eeb610] font-bold rounded-xl text-sm px-4 py-3 shadow-md transition-all"
      >
        {{ currentLang === "TH" ? "ตกลง" : "Confirm" }}
      </button>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>